// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDatasIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDatasIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDatasIconOutlined = function DrrpDatasIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDatasIconOutlinedSvg
  }));
};

DrrpDatasIconOutlined.displayName = 'DrrpDatasIconOutlined';
export default React.forwardRef(DrrpDatasIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDatasIconOutlined.js
// module id = 2545
// module chunks = 0